import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { AuthContext } from './../../Context/AuthContext.js';
import Loader from './../../Components/Loader/Loader.js';

function RequireAuth() {
    const { user, authReady } = useContext(AuthContext);
    const location = useLocation();

    if (!authReady) {
        return <Loader />;
    }

    if (!user) {
        const next = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/login?next=${next}`} replace />;
    }

    return <Outlet />;
}

export default RequireAuth;
